import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// project-imports
import router from 'routes';
import Locales from 'components/Locales';

// ==============================|| APP ||============================== //

export default function App() {
  return (
    <Locales>
      <RouterProvider router={router} />
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} closeOnClick pauseOnHover />
    </Locales>
  );
}
